import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NbDialogRef } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';
import { resourceTypes } from '@shared/constants/resourceTypes';
import { IAddMoreResources } from '@shared/interfaces/resources/add-more-resources';
import { AlertService } from '@shared/services/alert.service';
import { ApiService } from '@shared/services/api.service';
import { UserService } from '@shared/modules/account/services/user.service';

@Component({
  selector: 'app-add-more-resources-modal',
  templateUrl: './add-more-resources-modal.component.html',
  styleUrls: ['./add-more-resources-modal.component.scss']
})
export class AddMoreResourcesModalComponent implements OnInit {
  resourceTypes: Readonly<any> = resourceTypes;

  @Input() resource: string = "";
  @Input() currentCount: number = 0;
  @Input() priceForOneUnit: number = 0;
  @Input() totalCount: number = 0;
  @Input() totalLimit: number = 0;
  @Input() title: string = "";
  @Input() icon: string = "";
  @Input() currency: number = 0;
  @Input() isActive: boolean = false;

  additionalResources = 1;
  price: number = 0;

  constructor(
    protected dialogRef: NbDialogRef<AddMoreResourcesModalComponent>,
    private api: ApiService,
    private translate: TranslateService,
    private router: Router,
    private alertService: AlertService,
    private userService: UserService) { }

  ngOnInit() {
    this.price = this.priceForOneUnit;
  }

  cancel(): void {
    this.dialogRef.close();
  }

  onChangeRangeValue(value: number): void {
    this.additionalResources = value;
    this.price = +(value * this.priceForOneUnit).toFixed(2);
  }

  getTooltipContent(): string {
    switch (this.resource) {
      case resourceTypes.devices:
        return "tooltips.add-more-devices";
      case resourceTypes.transfer:
        return "tooltips.add-more-transfer";
      case resourceTypes.users:
        return "tooltips.add-more-users";
      default:
        return "tooltips.add-more-transfer";
    }
  }

  getDescriptionContent(): string {
    let text = "";

    switch (this.resource) {
      case resourceTypes.devices:
        text = text.concat(this.translate.instant("stats-and-resources.devices-slots-includes-your-plan"));
        text = text.concat(" (");
        text = text.concat(this.translate.instant("stats-and-resources.used"));
        text = text.concat("/");
        text = text.concat(this.translate.instant("stats-and-resources.total"));
        text = text.concat("). ");
        text = text.concat(this.translate.instant("stats-and-resources.remove-or-buy-more-slots"));
        break;
      case resourceTypes.transfer:
        text = text.concat(this.translate.instant("stats-and-resources.transfer-in-your-plan"));
        text = text.concat(" (");
        text = text.concat(this.translate.instant("stats-and-resources.used"));
        text = text.concat("/");
        text = text.concat(this.translate.instant("stats-and-resources.total"));
        text = text.concat("). ");
        text = text.concat(this.translate.instant("stats-and-resources.you-must-purchase-transfer"));
        break;
      case resourceTypes.users:
        text = this.translate.instant("stats-and-resources.exhausted-free-user-resources");
        break;
    }
    return text;
  }

  payNow() {
    const data: IAddMoreResources = {
      type: this.resource,
      returnUrl: this.router.url,
      quantity: this.additionalResources
    };

    this.api
      .postAddResources(data)
      .subscribe({
        next: res => {
          this.userService.setPaymentsCookie();
          window.open(res.redirectUrl, '_self');
        },
        error: error => {}
      });
  }

  get chartData(): Array<{ name: string, value: number }> {
    return [
      {
        name: "",
        value: this.currentCount
      },
      {
        name: "",
        value: Math.max(0, this.totalCount - this.currentCount)
      }
    ];
  }

}
